<template>
 <v-dialog v-model="show" persistent max-width="450px">
    <v-card>
                 <v-toolbar
          color="green lighten-3"
          dark
        >

          <v-toolbar-title   class="headline">Ny Kartläggning</v-toolbar-title>
        </v-toolbar>
            <v-card-text>
              <v-container>
                 <v-flex cols="12" sm="6" md="4">
                          <v-text-field
                      label="Namn"
                      hint="Skriv bara elevens initialer"
                      required
                      v-model="newMap.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex cols="12" sm="6" md="4">
                    <!-- <v-text-field
                      label="Frågeställning"
                      hint="Vill du berätta om varför kartläggning görs? Detta kommer lärarna se innan de fyller i den."
                      v-model="newMap.description"
                      required
                    ></v-text-field> -->

                  </v-flex>
                    <h2>Deadline</h2>
    <v-date-picker color="green lighten-1" v-model="newMap.deadline"></v-date-picker>


          <v-select
                      v-model="newMap.class"
                      :items="classes"
                      item-text="name"
                      item-value="id"
                      attach
                      chips
                      label="Klass"
                      hint="Vilken klass går eleven i?"
                      
                    ></v-select>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
        <v-btn dark color="red darken-1" @click="show = false"> Avbryt </v-btn>

                            <v-btn
                color="green lighten-1"
                text
                dark
                @click="change()"
          
              >
                Skapa och skicka ut!
              </v-btn>
            </v-card-actions>
          </v-card>
 </v-dialog>
</template>
<script>
import { mapActions,mapGetters } from "vuex";
export default {
    name:"Questions",

  computed: {
    
    ...mapGetters(['schoolID', 'user']),
    ...mapGetters('classesAP', ['classes']),
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
    },
    props:{
        // schoolId: String,
        // id:String,
        value: Boolean
    },
data() {
    return {
      //  classes: [{name: "1S", id: "1"},{name: "3F", id: "1"},{name:"2D", id: "1"}]    ,
         update:false ,
            newMap: {  },
    };
  },

  methods: {
    ...mapActions("mappings", ["createMapping"]),
    ...mapActions(['showSuccessSnackbar']),
  change(){
    this.newMap.schoolId= this.schoolID;
         this.newMap.EHTId= this.user.id;
           if (typeof this.newMap.deadline == "string")
       this.newMap.deadline=  Date.parse(this.newMap.deadline);
    // let output={teacherID: this.id, answers: this.Answers,step: rest}
      //  (this.newMap)

      this.createMapping(this.newMap);
  this.showSuccessSnackbar("Kartläggningen är skapad. Bra jobbat!")
    //   (this.newMap)
     this.show = false;
  }
    
  }
}
</script>
<style >

</style>